module.exports = __webpack_public_path__ + "img/1f31e.1ad4f45.svg";